import React, { useState, useEffect } from "react";
import img from "../../assets/images/zqf/zqfpage1.png";
import img2 from "../../assets/images/zqf/zqfpage2.png";
import img3 from "../../assets/images/zqf/zqfpage3.png";
import TalkShade from "./talkShade";
import ImgShade from "./imgShade";
import ImgShade2 from "./imgShade2";
import talkshade from "../../assets/images/zqf/zqf-talk.png";
import talkshade2 from "../../assets/images/zqf/zqf-talk2.png";
import hotshade from "../../assets/images/zqf/hotshade.png";
import { queryArchivesList } from "../../service";
import cls from "classnames";
import "./index.scss";

export default function ZQF({ setToPage }) {
  let floor = ["房间一", "房间二", "房间三"];
  const [floorAt, setFloorAt] = useState(0); //0 房间一 1房间二 2房间三
  const [show, setShow] = useState();

  // 处理楼层切换
  const handleFloorChange = (index) => {
    if (index !== floorAt) {
      setShow();
      setTimeout(() => {
        setFloorAt(index);
      }, 300);
    }
  };

  const [linkdata, setLinkData] = useState([]);
  const [linkid, setLinkId] = useState();
  useEffect(() => {
    if (floorAt === 0 || floorAt === 2) {
      queryArchivesList({
        resource: floorAt === 0 ? "MCJS" : "XQGY",
        pagination: {
          size: 0,
          page: 0,
        },
      }).then((res) => {
        setLinkData(res?.records);
      });
    }
  }, [floorAt]);
  return (
    <div className="common-page zqf-page  animate__animated animate__fadeIn animate__faster ">
      <div className="floor">
        {floor.map((item, index) => {
          return (
            <div
              className={cls("item", { active: index === floorAt })}
              key={index}
              onClick={() => {
                handleFloorChange(index);
              }}
            >
              <span> {item}</span>
              <i></i>
            </div>
          );
        })}
      </div>
      <div className="imgbox">
        {floorAt === 0 && (
          <div className="one">
            <img src={img} alt="" className="bg  " />
            <div
              className="hot hot1"
              onClick={() => {
                setShow("talk");
              }}
            ></div>
            {linkdata?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="hot"
                  style={{
                    top: item?.extension1,
                    left: item?.extension2,
                  }}
                  onClick={() => {
                    setShow("link");
                    setLinkId(item.id);
                  }}
                ></div>
              );
            })}

            <div
              className="talkbtn talk animate__animated animate__pulse animate__faster	 animate__infinite"
              onClick={() => {
                setShow("hot");
              }}
            ></div>
          </div>
        )}
        {floorAt === 1 && (
          <div className="two">
            <img src={img2} alt="" className="bg" />
            <div
              className="hot hot1"
              onClick={() => {
                setShow("page2link");
              }}
            ></div>

            <div
              className="talkbtn talk animate__animated animate__pulse animate__faster	 animate__infinite"
              onClick={() => {
                setShow("page2talk");
              }}
            ></div>
          </div>
        )}
        {floorAt === 2 && (
          <div className="three">
            <img src={img3} alt="" className="bg" />
            <div
              className="hot hot1"
              onClick={() => {
                setShow("page3link1");
              }}
            ></div>
            {linkdata?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="threehot"
                  style={{
                    top: item?.extension1,
                    left: item?.extension2,
                  }}
                  onClick={() => {
                    setShow("link");
                    setLinkId(item.id);
                  }}
                ></div>
              );
            })}
          </div>
        )}
      </div>

      {/* 对话 */}
      {show === "talk" && <TalkShade setShow={setShow} img={talkshade} />}
      {show === "hot" && (
        <TalkShade
          setShow={setShow}
          img={hotshade}
          style={{ width: "40.375rem", height: "18.9375rem" }}
        />
      )}
      {show === "page2talk" && (
        <TalkShade
          setShow={setShow}
          img={talkshade2}
          style={{ width: "40.375rem", height: "21.6875rem" }}
        />
      )}
      {show === "link" && (
        <ImgShade setShow={setShow} linkid={linkid} floorAt={floorAt} />
      )}
      {show === "page2link" && (
        <ImgShade2 setShow={setShow} floorAt={floorAt} />
      )}
      {show === "page3link1" && (
        <ImgShade2 setShow={setShow} floorAt={floorAt} />
      )}
      <div
        className="back"
        onClick={() => {
          setToPage();
        }}
      ></div>
    </div>
  );
}
